let pillarWeightCopyHandlerBound = false;

function handlePillarWeightCopy(e) {
  const btn = e.target.closest('.pillar-weight-copy-btn');
  if (!btn) return;

  const inputContainer = btn.closest('.col-4');
  if (!inputContainer) return;

  const input = inputContainer.querySelector('.pillar-weight-input');
  if (!input) return;

  const form = btn.closest('form');
  const targets = form
    ? form.querySelectorAll('.pillar-weight-input')
    : document.querySelectorAll('.pillar-weight-input');

  targets.forEach(el => { el.value = input.value; });
}

export default class AdminDataFrameworksPillarsEdit {

  constructor() {}

  render() {
    // Delegated handler bound once at module scope to avoid duplicate Turbo listeners.
    // Scopes the copy to all .pillar-weight-input fields within the same form.
    if (pillarWeightCopyHandlerBound) return;

    document.addEventListener('click', handlePillarWeightCopy);
    pillarWeightCopyHandlerBound = true;
  }

}
